import { ButtonPrimary } from "components/Atoms/Button";
import { PhosphorDownloadSimple } from "components/Atoms/PhosphorIcon";
import React from "react";

interface Props {
  downloadFileUrl: string
}

export const DownloadInvoiceButton = (props: Props) => {
  return <ButtonPrimary
    iconLeft={PhosphorDownloadSimple}
    label={RESX.InvoiceDocument.DownloadInvoice}
    href={`${props.downloadFileUrl}?inline=false`}
  />
}